import { useMutation, useQueryClient } from '@tanstack/react-query';

import apiClient from '../apiClient';
import { Slide } from '@/types/category';

export const useUpdateSlide = () => {
  const queryClient = useQueryClient();

  return useMutation<any, unknown, any>(
    async (payload: { id: string; slide: Slide }) => {
      console.log(payload);
      return await apiClient
        .patch(`/banners/${payload.id}`, payload.slide, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((res) => res.data);
    },
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries({ queryKey: ['GetSlides'] });
      },
    },
  );
};
